import { call, put, select } from "redux-saga/effects";
import { eventAlbumConstants as C } from "../actions/constants/eventAlbumConstants";
import { albumBuilderConstants } from "@/actions/constants/albumBuilderConstants";
import { commonActions } from "../actions/commonAction";
import {
    generateAlbumApi,
    fetchEventAlbumApi,
    fetchEventAlbumBySelectionApi,
    updateAlbumPagesApi,
    sendAlbumReviewApi,
    customerViewAlbumApi,
    customerApproveAlbumApi,
    fetchAlbumService,
    fetchAlbumPageService,
    saveAlbumPage,
    saveAlbumPages,
    createAlbumPage,
    deleteAlbumPage,
    createBackgroundSasService,
    getAlumBackgroundService, fetchPagesApi
} from "../services/eventAlbumService";
import { applyPageHistory } from "@/utils/albumBuilderHelper";
import { PayloadAction } from "@reduxjs/toolkit";

export function* generateEventAlbumSaga(action: any): Generator<any, void, any> {
    try {
        const { selectionId } = action.payload;
        const response = yield call(generateAlbumApi, selectionId);
        if (response?.success) {
            yield put({ type: C.generateSuccess, payload: response.resultObject });
        } else {
            const msg = response?.message || "Failed to generate album";
            yield put({ type: C.generateFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";
        yield put({ type: C.generateFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}

export function* fetchEventAlbumSaga(action: any): Generator<any, void, any> {
    try {
        const response = yield call(fetchEventAlbumApi, action.payload);
        if (response?.success) {
            yield put({ type: C.fetchSuccess, payload: response.resultObject });
        } else {
            yield put({
                type: C.fetchFailure,
                payload: response?.message || "Failed to fetch event album",
            });
        }
    } catch (error: any) {
        yield put({ type: C.fetchFailure, payload: error?.message || "An error occurred" });
    }
}

export function* fetchEventAlbumBySelectionSaga(action: any): Generator<any, void, any> {
    try {
        const { selectionId } = action.payload;
        const response = yield call(fetchEventAlbumBySelectionApi, selectionId);
        if (response?.success) {
            yield put({ type: C.fetchBySelectionSuccess, payload: response.resultObject });
        } else {
            yield put({
                type: C.fetchBySelectionFailure,
                payload: response?.message || "Failed to fetch event album",
            });
        }
    } catch (error: any) {
        yield put({
            type: C.fetchBySelectionFailure,
            payload: error?.message || "An error occurred",
        });
    }
}

export function* updateAlbumPagesSaga(action: any): Generator<any, void, any> {
    try {
        const { albumId, pages, pageOrder } = action.payload;
        const response = yield call(updateAlbumPagesApi, albumId, pages, pageOrder);
        if (response?.success) {
            yield put({ type: C.updatePagesSuccess, payload: response.resultObject });
        } else {
            const msg = response?.message || "Failed to save album pages";
            yield put({ type: C.updatePagesFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";
        yield put({ type: C.updatePagesFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}

export function* sendAlbumReviewSaga(action: any): Generator<any, void, any> {
    try {
        const { albumId, expiresInDays } = action.payload;
        const response = yield call(sendAlbumReviewApi, albumId, expiresInDays);
        if (response?.success) {
            yield put({ type: C.sendReviewSuccess, payload: response.resultObject });
        } else {
            const msg = response?.message || "Failed to send album review";
            yield put({ type: C.sendReviewFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";
        yield put({ type: C.sendReviewFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}

export function* customerViewAlbumByTokenSaga(action: any): Generator<any, void, any> {
    try {
        const { reviewToken } = action.payload;
        const response = yield call(customerViewAlbumApi, { reviewToken });
        if (response?.success) {
            yield put({ type: C.customerTokenViewSuccess, payload: response.resultObject });
        } else {
            yield put({
                type: C.customerTokenViewFailure,
                payload: response?.message || "Invalid or expired review link",
            });
        }
    } catch (error: any) {
        yield put({
            type: C.customerTokenViewFailure,
            payload: error?.message || "An error occurred",
        });
    }
}

export function* customerViewAlbumSaga(action: any): Generator<any, void, any> {
    try {
        const { identifier, reviewToken } = action.payload;
        const response = yield call(customerViewAlbumApi, { identifier, reviewToken });
        if (response?.success) {
            yield put({ type: C.customerViewSuccess, payload: response.resultObject });
        } else {
            yield put({
                type: C.customerViewFailure,
                payload: response?.message || "Failed to load album",
            });
        }
    } catch (error: any) {
        yield put({ type: C.customerViewFailure, payload: error?.message || "An error occurred" });
    }
}

export function* customerApproveAlbumSaga(action: any): Generator<any, void, any> {
    try {
        const { albumId, reviewToken, accessCode, comment, func } = action.payload;
        const response = yield call(customerApproveAlbumApi, albumId, {
            reviewToken,
            accessCode,
            comment,
            func,
        });
        if (response?.success) {
            yield put({ type: C.customerApproveSuccess, payload: response.resultObject });
        } else {
            yield put({
                type: C.customerApproveFailure,
                payload: response?.message || "Failed to approve album",
            });
        }
    } catch (error: any) {
        yield put({
            type: C.customerApproveFailure,
            payload: error?.message || "An error occurred",
        });
    }
}

export function* fetchAlbum(action: any): Generator<any, void, any> {
    try {
        const { albumId, version } = action.payload;
        const response = yield call(fetchAlbumService, albumId);
        if (response.success) {
            yield put({
                type: albumBuilderConstants.fetchAlbumSuccess,
                payload: { album: response.resultObject, version },
            });
        } else {
            yield put({
                type: albumBuilderConstants.fetchAlbumFailure,
                payload: response.message,
            });
        }
    } catch (error: any) {
        yield put({ type: albumBuilderConstants.fetchAlbumFailure });
    }
}
export function* fetchAlbumPage(action: any): Generator<any, void, any> {
    try {
        const { pageId } = action.payload;
        const existingPages: Record<string, any> = yield select((s: any) => s.albumBuilder.pages);
        if (existingPages[pageId]) return;

        yield put({ type: albumBuilderConstants.setPageLoading, payload: pageId });
        const response = yield call(fetchAlbumPageService, action.payload);
        if (response.success) {
            yield put({
                type: albumBuilderConstants.fetchAlbumPageSuccess,
                payload: response.resultObject,
            });
        } else {
            yield put({
                type: albumBuilderConstants.fetchAlbumPageFailure,
                payload: response.message,
            });
        }
    } catch (error: any) {
        yield put({ type: albumBuilderConstants.fetchAlbumPageFailure });
    }
}

export function* fetchPages(action: any): Generator<any, void, any> {
    try {
        const { pageIds, albumId } = action.payload;

        if (!pageIds?.length) return;

        const existingPages: Record<string, any> = yield select(
            (s: any) => s.albumBuilder.pages,
        );

        const missingPageIds = pageIds.filter(
            (pageId: string) => !existingPages[pageId],
        );

        if (!missingPageIds.length) return;

        const response = yield call(fetchPagesApi, {
            pageIds: missingPageIds,
            albumId,
        });

        if (response?.success) {
            yield put({
                type: albumBuilderConstants.fetchAlbumPagesSuccess,
                payload: response.resultObject,
            });
        } else {
            const msg = response?.message || "Failed to fetch album pages";

            yield put({
                type: albumBuilderConstants.fetchAlbumPagesFailure,
                payload: msg,
            });
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";

        yield put({
            type: albumBuilderConstants.fetchAlbumPagesFailure,
            payload: msg,
        });
    }
}

export function* saveAlbum(): Generator<any, void, any> {
    try {
        const dirtySheets: string[] = yield select((s: any) => s.albumBuilder.dirtySheets);
        const pages: Record<string, any> = yield select((s: any) => s.albumBuilder.pages);
        const pendingPageOperation = yield select((state: any) => state.albumBuilder.pendingPageOperation);
        const initialPages: Record<string, any> = yield select(
            (s: any) => s.albumBuilder.initialPages,
        );

        if (dirtySheets.length === 0) {
            yield put({ type: albumBuilderConstants.saveTemplateSuccess });
            return;
        }

        const payloadPages = dirtySheets
            .map((pageId) => {
                const page = pages[pageId];
                const initialPage = initialPages[pageId];
                if (!page && !initialPage) return null;
                const resolved = applyPageHistory(page, initialPage,pendingPageOperation);
                return {
                    pageId,
                    nodes: resolved.nodes,
                    backgroundColor: resolved.backgroundColor,
                    backgroundAssetId: resolved.backgroundAssetId,
                    backgroundOpacity: resolved.backgroundOpacity,
                    label: resolved.label,
                    history: resolved.history,
                };
            })
            .filter(Boolean);

        if (!payloadPages.length) {
            yield put({ type: albumBuilderConstants.saveTemplateSuccess });
            return;
        }

        const response: any = yield call(saveAlbumPages, payloadPages as any);

        if (response?.success) {
            for (const pageId of dirtySheets) {
                yield put({ type: albumBuilderConstants.saveSuccess, payload: pageId });
            }
            yield put({ type: albumBuilderConstants.saveTemplateSuccess });
        } else {
            const msg =
                response?.message ||
                response?.errorMessage ||
                "One or more sheets failed to save";
            yield put({
                type: albumBuilderConstants.saveTemplateFailure,
                payload: msg,
            });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "Save album failed";
        console.error(error);
        yield put({ type: albumBuilderConstants.saveTemplateFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}

export function* savePage(action: any): Generator<any, void, any> {
    try {
        const { pageId } = action.payload;
        const pages: Record<string, any> = yield select((s: any) => s.albumBuilder.pages);
        const pendingPageOperation = yield select((state: any) => state.albumBuilder.pendingPageOperation);
        const initialPages: Record<string, any> = yield select(
            (s: any) => s.albumBuilder.initialPage,
        );
        const page = pages[pageId];
        const initialPage = initialPages[pageId];
        if (!page) {
            yield put({ type: albumBuilderConstants.saveFailure, payload: "Sheet not found" });
            return;
        }
        const resolved = applyPageHistory(page, initialPage,pendingPageOperation);
        const response: any = yield call(saveAlbumPages, [
            {
                pageId,
                nodes: resolved.nodes,
                backgroundColor: resolved.backgroundColor,
                backgroundAssetId: resolved.backgroundAssetId,
                backgroundOpacity: resolved.backgroundOpacity,
                label: resolved.label,
                history: resolved.history,
            },
        ] as any);
        if (response?.success) {
            yield put({ type: albumBuilderConstants.saveSuccess, payload: pageId });
        } else {
            console.error(response?.errorMessage);
            const msg = response?.message || response?.errorMessage || "Save failed";
            yield put({ type: albumBuilderConstants.saveFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "Save failed";
        console.error(error);
        yield put({ type: albumBuilderConstants.saveFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}

export function* createPage(action: any): Generator<any, void, any> {
    try {
        const response = yield call(createAlbumPage, action.payload);
        if (response?.success) {
            const page = response.resultObject;
            const pageId = page._id ?? page.id;
            yield put({ type: albumBuilderConstants.createPageSuccess, payload: page });
            yield put({ type: albumBuilderConstants.setActivePage, payload: pageId });
        } else {
            const msg = response?.message || "Failed to create album page";
            yield put({ type: albumBuilderConstants.createPageFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";
        yield put({ type: albumBuilderConstants.createPageFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}

export function* deletePage(action: any): Generator<any, void, any> {
    try {
        const response = yield call(deleteAlbumPage, action.payload);
        if (response?.success) {
            yield put({
                type: albumBuilderConstants.deletePageSuccess,
                payload: action.payload.pageId,
            });
        } else {
            const msg = response?.message || "Failed to delete album page";
            yield put({ type: albumBuilderConstants.deletePageFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (error: any) {
        const msg = error?.message || "An error occurred";
        yield put({ type: albumBuilderConstants.deletePageFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}

export function* createBackgroundSas(
    action: PayloadAction<{ pageId: string; fileName: string }>,
): Generator<any, void, any> {
    try {
        const response = yield call(createBackgroundSasService, action.payload);
        if (response?.success) {
            yield put({
                type: albumBuilderConstants.createBackgroundSasSuccess,
                payload: response.resultObject,
            });
            yield put(commonActions.successResponse("Background uploaded successfully"));
        } else {
            const msg = response?.message || "Failed to generate background SAS URL";
            yield put({ type: albumBuilderConstants.createBackgroundSasFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (err: any) {
        const msg = err?.message || "An error occurred";
        yield put({ type: albumBuilderConstants.createBackgroundSasFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}
export function* getBackgroundSaga(
    action: PayloadAction<{
        eventId: string;
        studioId: string;
        serviceId: string;
    }>,
): Generator<any, void, any> {
    try {
        const response = yield call(getAlumBackgroundService, action.payload);
        if (response?.success) {
            yield put({
                type: albumBuilderConstants.getAlumBackgroundSuccess,
                payload: response.resultObject,
            });
        } else {
            const msg = response?.errorMessage;
            yield put({ type: albumBuilderConstants.getAlumBackgroundFailure, payload: msg });
            yield put(commonActions.errorResponse(msg));
        }
    } catch (err: any) {
        const msg = err?.message || "An error occurred";
        yield put({ type: albumBuilderConstants.createBackgroundSasFailure, payload: msg });
        yield put(commonActions.errorResponse(msg));
    }
}
